import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../styles/DetalleProfesional.css";
import { FiShare } from "react-icons/fi";

const ProfesionalDetail = () => {
  const { id } = useParams();
  const [profesional, setProfesional] = useState(null);
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfesional = useCallback(async () => {
    try {
      // Realiza las solicitudes a las APIs
      const [profesionalRes, especialidadesRes] = await Promise.all([
        axios.get(`https://vortexcode.cl/api/profesional/${id}`),
        axios.get("https://vortexcode.cl/api/especialidad"),
      ]);

      // Guarda los datos en el estado
      setProfesional(profesionalRes.data);
      setEspecialidades(especialidadesRes.data);
      setLoading(false);
    } catch (err) {
      console.error("Error al cargar los datos del profesional:", err);
      setError("Hubo un error al cargar los datos");
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchProfesional();
  }, [fetchProfesional]);

  const getEspecialidadNombre = (idEspecialidad) => {
    const especialidad = especialidades.find(
      (esp) => esp.id_especialidad === parseInt(idEspecialidad, 10)
    );
    return especialidad ? especialidad.nombre_especialidad : "Especialidad desconocida";
  };

  const handleShare = () => {
    if (!profesional) return;

    const shareData = {
      title: `Perfil de ${profesional.nombre_profesional}`,
      text: `Consulta el perfil de ${profesional.nombre_profesional} ${profesional.apaterno_profesional} en nuestro sitio.`,
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch((err) => console.error("Error al compartir:", err));
    } else {
      alert(`Copia este enlace para compartir: ${window.location.href}`);
    }
  };

  if (loading) return <div className="text-center mt-4">Cargando...</div>;
  if (error) return <div className="alert alert-danger mt-4">{error}</div>;

  return (
    <div>
      <div className="profile-page">
        <br />
        <div className="container mt-4">
          <div className="container">
            <div className="Box_container shadow-sm p-4 mb-4">
              <div className="MainInfo_imageContainer d-flex align-items-center">
                <img
                  src={profesional.img_profesional}
                  alt={`Foto de ${profesional.nombre_profesional}`}
                  className="rounded-circle me-3"
                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                />
                <div>
                  <h5 className="mb-0">{`${profesional.nombre_profesional} ${profesional.apaterno_profesional}`}</h5>
                  <h6 className="text-muted">
                    {getEspecialidadNombre(profesional.especialidad_id_especialidad)}
                  </h6>
                  <p>
                    Rango etario: De {profesional.rango_inferior} a {profesional.rango_superior}
                  </p>
                  <h4>Formación</h4>
                  <p>{profesional.nombre_formacion}</p>
                </div>
              </div>
              <div className="MainInfo_dataContainer mt-3 p-3">
                <p>{profesional.desc_profesional}</p>
              </div>

              <div className="MainInfo_ctaContainer mt-3">
                <button
                  className="btn btn-outline-success me-2"
                  onClick={() => (window.location.href = "/reserva")}
                >
                  Reserva tu hora
                </button>
                <button className="btn-compartir" id="BtnCompartir" onClick={handleShare}>
                  COMPARTIR <FiShare style={{ marginLeft: "6px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfesionalDetail;